import * as NavConst from '../components/constants/NavigationConstants';
import * as SweetAlert from '../components/common/utilities/ConfirmationAlert';
import { getApiPath, DELETE, USER, ROLE, GENERIC_PAGINATED_KEY_VALUE_LIST, LIST } from '../api/ApiConst';
import ApiCaller from '../api/ApiCaller';

export const User = {
  basePath: "user",
  formUrl: NavConst.USER_PROFILE,
  filePath: "User",
  tableDataUrl: LIST,
  label: "User",
  attributes: [{ name: "id", value: "id", type: "text", position: 0, formAttribute: false },
  { name: "Username", value: "username", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  { name: "Password", value: "password", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  { name: "name", value: "name", type: "text", position: 1, formAttribute: true, className: "form-control input-default" },
  {
    name: "Role", value: "roleId", type: "select", position: 2, formAttribute: true, isStatic: false, basePath: "role",
    dataListFunction: () => {
      const options = []
      var jsonRequest = { "page": 0, "size": 200, searchFilters: [], sortRules: [] };
      ApiCaller.callPostApi(getApiPath(ROLE, GENERIC_PAGINATED_KEY_VALUE_LIST), jsonRequest, {}, (response) => {
        response.data.map((d) => {
          options.push({ value: d.key, label: d.value })
        });
      }, (error) => {
        console.error(error);
      });
      return options
    }
  }

  ],
  actions: [
    { name: "Edit", iconClass: "fa fa-edit", type: "model", navigatePath: NavConst.UPDATE_TABLE_STRUCTURE, replaceData: ":updateTableName" },
    {
      name: "Delete", iconClass: "fa fa-trash", type: "alert", action: (url, refresh) => SweetAlert.isDeleteRecord(url, refresh),
      navigatePath: getApiPath(USER, DELETE), replaceData: "{recordId}"
    },
    { name: "Active", iconClass: "fa fa-circle-check", type: "alert", action: SweetAlert.isActiveRecord },
    { name: "InActive", iconClass: "fa fa-circle-xmark", type: "alert", action: SweetAlert.isInActiveRecord },
  ]
};



